import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line max-len
export const refEmailLine = '[Candidate Full Name] is a job candidate for a new career opportunity and has listed you as a reference.';

export const refEmailHeader = [
  <FormattedMessage id="emailPreview.refFirstName" defaultMessage="<Reference first name>" />,
  refEmailLine
];

export const refEmailFooter = <FormattedMessage id="emailPreview.surveyLink" defaultMessage="<Survey link>" />;

export const refEmailLabel = (
  <FormattedMessage
    id="messageTemplateSettings.reference"
    defaultMessage="Default email to references"
  />
);
